"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ticketTypes = exports.referralStatuses = void 0;
exports.referralStatuses = ['SENT', 'FAILED', 'ACCEPTED'];
exports.ticketTypes = ['TASK', 'BUG', 'NEW_FEATURE', 'IMPROVEMENT'];
//# sourceMappingURL=Misc.js.map